import { stornoE, stornoParKeres, eredetiKeres } from '../storno-par';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, IonModal, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { OsaValasztoComponent } from '../osa-valaszto/osa-valaszto.component';
import { NaploService } from '../naplo.service';
import { szamlakepAblakba } from '../szamlakep-ablak';
import { DataService } from '../../data.service';
import { NAPLO_OPCIOK } from '../naplo.opciok';
import { SzerkZar, SzerkZarService } from '../../components/szerk-zar/szerk-zar.service';

@Component({
  selector: 'app-naplo-konyveles',
  templateUrl: './konyveles.component.html',
  styleUrls: ['../naplo-shared.scss', './konyveles.component.scss'],
})
export class KonyvelesComponent implements OnInit, OnDestroy {
  @ViewChild('urlap') urlap?: ElementRef<HTMLElement>;
  @ViewChild('osaModal') osaModal: IonModal;
  @ViewChild('osaValaszto') osaValaszto?: OsaValasztoComponent;
  @ViewChild('partnerPickerModal') partnerPickerModal: IonModal;
  opciok = NAPLO_OPCIOK;
  tetelek: any[] = [];
  rovatok: any[] = [];
  partnerek: any[] = [];
  penztarak: any[] = [];
  gyujtok: any[] = [];
  szerk: any = null;
  /*  SZERKESZTÉSI ZÁR (backend/szerkesztes-zar.js) a megnyitott tételre – amíg más szerkeszti, nálunk
   *  csak olvasható. Új (mentetlen) tételnél nincs. */
  zarTetel: SzerkZar | null = null;
  private zarKor = 0;
  /** Zár kérése; ha a válasz megérkezéséig az űrlap már mást mutat, a késő zárat elengedjük. */
  private async zarKer(id: any) {
    this.zarEngedd();
    const kor = this.zarKor;
    const z = await this.szerkZar.foglal('naplo', 'naplo_tetel', id, { ujratolt: () => this.tetelUjratolt(String(id)) });
    if (kor !== this.zarKor) { z?.felenged(); return; }
    this.zarTetel = z;
  }
  private zarEngedd() { this.zarKor++; this.zarTetel?.felenged(); this.zarTetel = null; }
  /** Más szerkeszti – nálunk nem menthető / törölhető. */
  get zarTilt() { return !!this.zarTetel && !this.zarTetel.irhato; }
  szuro = '';
  keret: any = null;            // KATA/átalányadó/AAM keretfigyelés (a felső szint + `tovabbi`)
  partnerKereso = '';
  // OSA számlaválasztó (alapból tételsorokkal töltünk)
  osaSzuro = { dateFrom: '', dateTo: '', direction: 'inbound' as 'inbound' | 'outbound', reszletes: true };
  osaSzamlak: any[] = [];
  osaLoading = false;
  osaNezet: any = null;
  osaKijelolt = new Set<string>();   // csoportos könyveléshez kijelölt számlaszámok

  constructor(private naplo: NaploService, private http: HttpClient, private toast: ToastController, private alert: AlertController, private router: Router, private data: DataService,
              private route: ActivatedRoute, private szerkZar: SzerkZarService) {}

  ngOnDestroy() { this.zarEngedd(); }

  /** A „Tárgyi eszközhöz” ablak bizonylata (null: zárva). */
  hozamTetel: string | null = null;
  hozamKesz() { this.hozamTetel = null; this.ok('Hozzárendelve – a Tárgyi eszköz modul Megtérülés fülén látszik.'); }
  get aktiv() { return this.naplo.aktiv; }

  async ngOnInit() {
    await this.naplo.init();
    // Kettős könyvelésű ügyfélnél a kettős nézet nyílik (a „Könyvelés" menü ide irányít).
    if (this.aktiv.konyveles_mod === 'kettos') {
      const osa = this.route.snapshot.queryParamMap.get('osa') === '1';
      this.router.navigate(['/naplo/kettos'], { queryParams: { nezet: osa ? 'osa' : 'kontir' }, replaceUrl: true });
      return;
    }
    if (!this.aktiv.ugyfelId) return;
    await Promise.all([this.betoltTetelek(), this.betoltTorzsek(), this.betoltKeret(), this.bevsorNevekBetolt()]);
    this.uj();
    // A főmenü „Számla behúzása" pontja ide visz, `?osa=1`-gyel: a választó nyíljon meg. Utána a
    // paramétert levesszük, hogy a menüpont újra kiválasztva ismét megnyissa.
    this.route.queryParamMap.subscribe(async (q) => {
      // Mélylinkek a Naplókból: `?tetel=<id>` = a tétel módosítása; `?uj=pénztár|bank|bevetel|kiadas`
      // = új tétel a megfelelő pénzforgalmi hellyel / iránnyal. Feldolgozás után levesszük őket.
      const tetel = q.get('tetel'), ujFajta = q.get('uj');
      const vissza = q.get('vissza');
      if (vissza && vissza.startsWith('/naplo/')) this.visszaUt = vissza;
      else if (!tetel && !ujFajta && !this.parameterLevetel) this.visszaUt = null;
      this.parameterLevetel = false;
      if (tetel) await this.szerkeszt({ id: tetel });
      else if (ujFajta) this.ujFajta(ujFajta);
      if (q.get('osa') === '1') this.osaIndit();
      if (tetel || ujFajta || vissza || q.get('osa') === '1') {
        this.parameterLevetel = true;
        this.router.navigate([], { relativeTo: this.route, queryParams: { osa: null, tetel: null, uj: null, vissza: null }, queryParamsHandling: 'merge', replaceUrl: true });
      }
    });
  }

  /** A kirajzolandó keretek: a fő keret, majd a `tovabbi` (pl. átalányadó ÉS alanyi adómentes ügyfélnél az AAM). */
  get keretek(): any[] {
    const k = this.keret;
    if (!k) return [];
    return [k, ...(Array.isArray(k.tovabbi) ? k.tovabbi : [])];
  }
  /** A keretsáv felirata a keret fajtája szerint (régi kiszolgálónál a kata/atalanyado jelölőből). */
  keretCim(k: any): string {
    const fajta = k?.fajta || (this.keret?.kata ? 'kata' : 'atalany');
    if (fajta === 'aam') return 'Alanyi adómentesség értékhatára';
    return fajta === 'kata' ? 'KATA-keret' : 'Átalányadó-keret';
  }

  async betoltKeret() {
    try { const k: any = await this.naplo.get('/keret/' + this.aktiv.ugyfelId + this.naplo.evq()); this.keret = k?.aktiv ? k : null; }
    catch { this.keret = null; }
  }

  async betoltTorzsek() {
    const id = this.aktiv.ugyfelId;
    // EGY törzs hibája NE döntse be a teljes nézetet: eddig a Promise.all elszállása megszakította az
    // ngOnInit-et a `this.uj()` ELŐTT, így a szerkesztő-űrlap nem jött létre, és az alsó gombok
    // (módosítás, számlakép, új tétel) nem reagáltak. Mindegyik törzs hibatűrő, üres listára esik vissza.
    const biztos = (p: Promise<any>) => Promise.resolve(p).then((r) => r || []).catch(() => []);
    [this.rovatok, this.partnerek, this.penztarak, this.gyujtok] = await Promise.all([
      biztos(this.naplo.get('/rovatok/' + id)), biztos(this.naplo.get('/partnerek/' + id)),
      biztos(this.naplo.get('/penztarak/' + id)), biztos(this.naplo.get('/gyujtok/' + id)),
    ]);
  }
  async betoltTetelek() {
    try { this.tetelek = await this.naplo.get('/naplofokonyv/' + this.aktiv.ugyfelId + this.naplo.evq()).then((r: any) => r.sorok || []); }
    catch { this.hiba('Nem sikerült betölteni a tételeket.'); }
  }

  get szurtTetelek() {
    const s = this.szuro.trim().toLowerCase();
    if (!s) return this.tetelek;
    return this.tetelek.filter(t => (t.partner_nev || '').toLowerCase().includes(s) || (t.bizonylatszam || '').toLowerCase().includes(s) || (t.megjegyzes || '').toLowerCase().includes(s) || String(t.sorszam) === s);
  }

  ujSor() { return { rovat_id: null, rovatszam: null, oszlop: null, irany: 'kiadas', afa_kulcs: null, bevallas_sor: null, netto: null, afa: null, brutto: null }; }

  uj() {
    this.zarEngedd();   // új (még mentetlen) tétel – nincs zár
    this.bevTanult = new Map(); this.bevTanultKinek = '';   // partner nélkül nincs tanult sor
    const ma = new Date().toISOString().slice(0, 10);
    const utolso = this.tetelek[this.tetelek.length - 1];
    this.szerk = {
      ugyfel_id: this.aktiv.ugyfelId, datum: utolso?.datum || ma, afa_esedekesseg: utolso?.datum || ma,
      bizonylatszam: '', penztar_id: this.penztarak[0]?.id || null, partner_id: null, partner_nev: '',
      gyujto_id: null, megjegyzes: '', sorok: [this.ujSor()],
    };
    this.sorokIgazit();
  }

  /** Új tétel a Naplókból: pénzforgalmi hely (pénztár/bank) vagy irány (bevétel/kiadás) előre kiválasztva. */
  ujFajta(f: string) {
    this.uj();
    if (f === 'penztar' || f === 'bank') {
      const p = this.penztarak.find((x: any) => x.tipus === f);
      if (p) this.szerk.penztar_id = p.id;
    }
    if (f === 'bevetel' || f === 'kiadas') this.szerk.sorok[0].irany = f;
    this.urlapFokusz();
  }

  async szerkeszt(t: any) {
    //  A szerkesztési zárat a betöltéssel párhuzamosan kérjük; ha a betöltés nem sikerül, elengedjük.
    this.zarKer(t.id);
    const kor = this.zarKor;
    try { await this.tetelBetolt(t.id); }
    catch (e) { if (kor === this.zarKor) this.zarEngedd(); throw e; }
  }
  /** A zár felszabadulásakor / a sáv „Újratöltés”-ére: friss adat, ha még ez a tétel van nyitva. */
  private async tetelUjratolt(id: string) { if (this.szerk?.id != null && String(this.szerk.id) === id) await this.tetelBetolt(id); }
  private async tetelBetolt(id: any) {
    const teljes: any = await this.naplo.get('/tetel/' + id);
    this.szerk = {
      ...teljes, ugyfel_id: this.aktiv.ugyfelId,
      sorok: (teljes.sorok || []).map((s: any) => ({ ...s, afa_kulcs: s.afa_kulcs != null ? Number(s.afa_kulcs) : null })),
    };
    if (!this.szerk.sorok.length) this.szerk.sorok = [this.ujSor()];
    this.sorokIgazit();
    this.urlapFokusz();
    this.bevTanultBetolt();   // az újonnan hozzáadott sorokhoz (a mentett sorok bevallási sora marad)
    await this.szamlaKapcsolatBetolt();
  }

  /*  MÓDOSÍTÓ SZÁMLA ÉS AZ EREDETIJE (backend: szamla-modositas.js): a kettő együtt érvényes.
   *  0 Ft-os módosító → könyvelés nélküli csatolás; összeggel → könyvelés, és mentéskor kötjük. */
  modositoPar: any = null;
  szamlaKapcsolat: any = null;
  async szamlaKapcsolatBetolt() {
    this.szamlaKapcsolat = null;
    const sz = this.szerk?.osa_szamlaszam || this.szerk?.bizonylatszam;
    if (!sz || !this.szerk?.id) return;
    try {
      const r: any = await this.naplo.get(`/osa/kapcsolat/${this.aktiv.ugyfelId}?szamlaszam=${encodeURIComponent(sz)}`);
      if (r?.eredeti || r?.modositok?.length) this.szamlaKapcsolat = r;
    } catch { /* nincs kapcsolat */ }
  }
  async kapcsoltNyit(tetelId: string | null) {
    if (!tetelId) return this.hiba('A kapcsolt számla könyvelés nélkül csatolt (0 Ft-os módosító) – nincs saját tétele.');
    await this.szerkeszt({ id: tetelId });
  }
  async osaCsatol(s: any) {
    const a = await this.alert.create({ header: 'Módosító számla csatolása',
      message: `A(z) ${s.szamlaszam} 0 Ft-os módosító számla – könyvelni nem kell, de az eredetivel (${s.eredeti_szamlaszam}) együtt érvényes. Összekössem?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Csatolás', role: 'ok' }] });
    await a.present();
    if ((await a.onDidDismiss()).role !== 'ok') return;
    try {
      const r: any = await this.naplo.post(`/osa/modosito/${this.aktiv.ugyfelId}`, { modosito: s });
      await this.osaValaszto?.cacheBetolt();
      this.ok(r?.fuggo ? `${s.szamlaszam} csatolva. ${r.uzenet}` : `${s.szamlaszam} az eredetihez (${s.eredeti_szamlaszam}) csatolva.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült csatolni.'); }
  }

  addSor() { this.szerk.sorok.push(this.ujSor()); }   // korlátlan tételsor

  /*  KORLÁTLAN SOR, a könyvelőprogramok rácsa szerint: az utolsó sor mindig üres – amint abba
   *  írsz, alá új sor kerül. Mentéskor az üres sorok kimaradnak. */
  private sorUres(s: any) { return !s.rovat_id && !s.rovatszam && !Number(s.netto) && !Number(s.brutto); }
  sorokIgazit() {
    if (!this.szerk) return;
    const l = this.szerk.sorok || (this.szerk.sorok = []);
    while (l.length > 1 && this.sorUres(l[l.length - 1]) && this.sorUres(l[l.length - 2])) l.pop();
    if (!l.length || !this.sorUres(l[l.length - 1])) l.push(this.ujSor());
  }
  get kitoltottSorok(): any[] { return (this.szerk?.sorok || []).filter((s: any) => !this.sorUres(s)); }
  sorOsszeg(mezo: 'netto' | 'afa' | 'brutto') {
    return this.kitoltottSorok.reduce((a: number, s: any) => a + (Number(s[mezo]) || 0) * (s.irany === 'kiadas' ? -1 : 1), 0);
  }

  /** Kerekítés egész forintra (a könyvelőprogramok „Kerekítés” gombja). */
  kerekites() {
    for (const s of this.kitoltottSorok) {
      for (const m of ['netto', 'afa', 'brutto']) if (s[m] != null && s[m] !== '') s[m] = Math.round(Number(s[m]));
    }
  }

  /** Bizonylatszám léptetése: a végén álló szám eggyel nő (vagy csökken). */
  bizonylatLep(irany: 1 | -1) {
    const b = String(this.szerk?.bizonylatszam || '');
    const m = b.match(/^(.*?)(\d+)$/);
    if (!m) { this.szerk.bizonylatszam = b ? b + '1' : '1'; return; }
    const n = Math.max(0, Number(m[2]) + irany);
    this.szerk.bizonylatszam = m[1] + String(n).padStart(m[2].length, '0');
  }
  /** Az utolsó tétel bizonylatszámát lépteti tovább (új tételnél). */
  kovetkezoBizonylat() {
    const utolso = [...this.tetelek].reverse().find((t: any) => t.bizonylatszam && /\d+$/.test(t.bizonylatszam));
    if (!utolso) return;
    this.szerk.bizonylatszam = utolso.bizonylatszam;
    this.bizonylatLep(1);
  }

  /*  EGYENLEGEK a naplófőkönyv soraiból: a kiválasztott pénzforgalmi hely nyitó egyenlege a
   *  tétel dátuma előtt, és a záró a most rögzített tétellel együtt. */
  private penztarAzon(id: string | null) { return this.penztarak.find((p: any) => p.id === id)?.azonosito || null; }
  private egyenleg(szuro: (t: any) => boolean) {
    return (this.tetelek || []).filter(szuro).reduce((a: number, t: any) => a + (Number(t.bevetel) || 0) - (Number(t.kiadas) || 0), 0);
  }
  get nyitoEgyenleg(): number {
    const az = this.penztarAzon(this.szerk?.penztar_id); const d = this.szerk?.datum || '9999';
    return az ? this.egyenleg((t) => t.penztar_azon === az && t.datum < d && t.id !== this.szerk?.id) : 0;
  }
  get zaroEgyenleg(): number { return this.nyitoEgyenleg + this.sorOsszeg('brutto'); }
  get bankEgyenleg(): number { return this.egyenleg((t) => t.penztar_tipus === 'bank'); }
  get penztarEgyenleg(): number { return this.egyenleg((t) => t.penztar_tipus === 'penztar'); }

  /** Enterre a következő mezőre lép (a könyvelőprogramok billentyűzetes rögzítése). */
  enterTovabb(e: Event) {
    const cel = e.target as HTMLElement;
    if (!cel || cel.tagName === 'TEXTAREA' || cel.tagName === 'BUTTON') return;
    const mezok = Array.from(this.urlap?.nativeElement.querySelectorAll<HTMLElement>('input:not([disabled]):not([type=checkbox]), select:not([disabled])') || []);
    const i = mezok.indexOf(cel);
    if (i >= 0 && i < mezok.length - 1) { e.preventDefault(); mezok[i + 1].focus(); (mezok[i + 1] as HTMLInputElement).select?.(); }
  }
  urlapFokusz() {
    setTimeout(() => {
      this.urlap?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.urlap?.nativeElement.querySelector<HTMLInputElement>('input')?.focus();
    }, 50);
  }
  rovatNev(s: any): string { return this.rovatok.find((r: any) => r.id === s.rovat_id)?.nev || ''; }
  fmt0(n: any): string {
    const v = Number(n) || 0;
    const [e, t] = Math.abs(v).toFixed(Math.abs(v - Math.round(v)) < 0.005 ? 0 : 2).split('.');
    return (v < 0 ? '−' : '') + e.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (t ? ',' + t : '');
  }
  torolSor(i: number) { this.szerk.sorok.splice(i, 1); if (!this.szerk.sorok.length) this.szerk.sorok.push(this.ujSor()); }

  // Rovat kiválasztásakor (selectből) töltsük ki az oszlopot, irányt, alap áfa-kulcsot.
  rovatValt(sor: any) {
    const r = this.rovatok.find(x => x.id === sor.rovat_id);
    if (!r) return;
    this.rovatAlkalmaz(sor, r);
  }
  // Rovatszám begépelésekor: ha van pontos egyezés, felismeri ("tükör") és kitölti a sort.
  rovatTukor(sor: any) {
    const szam = String(sor.rovatszam || '').trim();
    if (!szam) { sor.rovat_id = null; return; }
    const r = this.rovatok.find(x => String(x.rovatszam).toLowerCase() === szam.toLowerCase());
    if (r) { this.rovatAlkalmaz(sor, r); sor.talalt = true; }
    else { sor.rovat_id = null; sor.talalt = false; }
  }
  private rovatAlkalmaz(sor: any, r: any) {
    sor.rovat_id = r.id;
    sor.rovatszam = r.rovatszam;
    sor.oszlop = r.oszlop;
    sor.irany = (r.oszlop === 1 || r.oszlop === 2) ? 'bevetel' : 'kiadas';
    if (r.afas && r.alap_afa_kulcs != null && (sor.afa_kulcs == null)) sor.afa_kulcs = Number(r.alap_afa_kulcs);
    this.bevSorElotolt(sor, r);
    sor.afas = !!r.afas; sor.talalt = true; sor.rovatNev = r.nev;
    this.szamol(sor);
  }

  // Nettó/áfa/bruttó automatikus számítása a kulcs alapján.
  szamol(sor: any) {
    const kulcs = Number(sor.afa_kulcs) || 0;
    const n = Number(sor.netto) || 0, b = Number(sor.brutto) || 0;
    //  Forintban EGÉSZ számok, fillér nincs (user, 2026-10-07); devizás tételnél centre kerekít.
    const k = (v: number) => (this.szerk?.deviza ? Math.round(v * 100) / 100 : Math.round(v));
    if (kulcs > 0) {
      if (b > 0) { sor.brutto = k(b); sor.afa = k(sor.brutto - sor.brutto / (1 + kulcs / 100)); sor.netto = k(sor.brutto - sor.afa); }
      else if (n > 0) { sor.netto = k(n); sor.afa = k(sor.netto * kulcs / 100); sor.brutto = k(sor.netto + sor.afa); }
    } else { sor.afa = 0; sor.brutto = k(n || b); sor.netto = k(n || b); }
    this.sorokIgazit();
  }

  // ---- Kereshető partner-modal ----
  partnerPickerNyit() { this.partnerKereso = ''; this.partnerPickerModal.present(); }
  get szurtPartnerek() {
    const s = this.partnerKereso.trim().toLowerCase();
    if (!s) return this.partnerek.slice(0, 100);
    return this.partnerek.filter(p => (p.nev || '').toLowerCase().includes(s) || (p.adoszam || '').toLowerCase().includes(s)).slice(0, 100);
  }
  partnerValaszt(p: any) {
    this.szerk.partner_id = p.id; this.szerk.partner_nev = p.nev;
    this.szerk.partnerHianyzik = false;
    this.partnerPickerModal.dismiss();
    this.bevTanultBetolt();
  }
  partnerTorles() { this.szerk.partner_id = null; this.szerk.partner_nev = ''; this.bevTanultBetolt(); }

  /* ══════════ TANULT BEVALLÁSI SOR (backend/naplo-bevsor-tanulas.js) ══════════
   *  Ha a könyvelő a sor bevallási sorát a rovat alapértékétől eltérőre állítja és elmenti, a
   *  rendszer megjegyzi partner + ÁFA-kulcs + irány szerint, és legközelebb ugyanannál a
   *  partnernél ezt ajánlja a rovat alapértéke helyett. Kézzel átírható; a mentett sort nem bántjuk. */
  private bevTanult = new Map<string, { sor: string; gyakorisag: number; partner: string }>();
  private bevTanultKinek = '';
  async bevTanultBetolt() {
    const nev = String(this.szerk?.partner_nev || '').trim();
    const id = String(this.szerk?.partner_id || '');
    const kinek = `${nev}|${id}`;
    this.bevTanultKinek = kinek;
    let l: any[] = [];
    if (nev) {
      try { l = (await this.naplo.get(`/bevsor-tanult/${this.aktiv.ugyfelId}?partner_nev=${encodeURIComponent(nev)}${id ? '&partner_id=' + encodeURIComponent(id) : ''}`)) as any[] || []; }
      catch { l = []; }
    }
    if (this.bevTanultKinek !== kinek) return;   // közben másik partner jött
    this.bevTanult = new Map((l || []).map((x: any): [string, { sor: string; gyakorisag: number; partner: string }] => [`${x.oldal}|${x.afa_kulcs}`,
      { sor: String(x.bevallas_sor || ''), gyakorisag: Number(x.gyakorisag) || 0, partner: String(x.partner_nev || nev) }]));
    //  Csak a gép töltötte sorokat igazítjuk (a mentett / kézzel írt bevallási sor marad).
    for (const s of this.szerk?.sorok || []) if (s._bevAuto !== undefined || s._osa) this.bevSorElotolt(s);
  }
  private bevKulcs(k: any): string { return k === null || k === undefined || k === '' ? '' : String(Number(k)); }
  private sorN(v: any): string { const t = String(v ?? '').trim(); return /^\d+$/.test(t) ? String(Number(t)) : t.toUpperCase(); }
  /*  A sor bevallási sora: a partnernél TANULT (partner + kulcs + irány) elsőbbséget kap a rovat
   *  alapértékével szemben. Kézzel írt vagy mentett sort nem írunk felül. A behúzott NAV-számla
   *  sorára (_osa) eddig sem került rovat-alapérték – ott csak a tanult sor töltődik. */
  bevSorElotolt(sor: any, r?: any) {
    if (!sor) return;
    if (sor.bevallas_sor && sor.bevallas_sor !== sor._bevAuto) return;
    const rovat = r || this.rovatok.find((x: any) => x.id === sor.rovat_id);
    const rovatAlap = rovat?.alap_bevallas_sor || null;
    const t = this.bevTanult.get(`${sor.irany === 'bevetel' ? 'fiz' : 'lev'}|${this.bevKulcs(sor.afa_kulcs)}`);
    const tanult = t?.sor && this.sorN(t.sor) !== this.sorN(rovatAlap) ? t : null;
    sor.bevallas_sor = tanult ? tanult.sor : (sor._osa ? null : rovatAlap);
    sor._bevAuto = sor.bevallas_sor;
    sor._bevTanult = tanult ? { ...tanult, alap: rovatAlap || '' } : null;
  }
  bevTanultLatszik(s: any): boolean { return !!(s?._bevTanult && s.bevallas_sor && s.bevallas_sor === s._bevTanult.sor); }
  bevTanultCim(s: any): string {
    const t = s?._bevTanult;
    if (!this.bevTanultLatszik(s)) return this.bevsorNev(s?.bevallas_sor);
    const kulcs = s.afa_kulcs != null && s.afa_kulcs !== '' ? `${Number(s.afa_kulcs)}%-os ` : '';
    return `Tanult érték: ${t.partner || 'ennél a partnernél'} ${kulcs}${s.irany === 'bevetel' ? 'bevételi' : 'kiadási'} tételeit `
      + `${t.gyakorisag}× a(z) ${t.sor}. sorra könyvelted${t.alap ? ` (a rovat alapértéke a(z) ${t.alap}. sor)` : ''}. Átírható.`
      + (this.bevsorNev(s.bevallas_sor) ? ` – ${this.bevsorNev(s.bevallas_sor)}` : '');
  }

  // Partner automatikus felismerése adószám/név alapján; ha nincs, felajánljuk a létrehozást.
  partnerAutoMatch(nev: string, adoszam?: string) {
    const ad = (adoszam || '').replace(/[-\s]/g, '').slice(0, 8);
    let p = ad ? this.partnerek.find(x => (x.adoszam || '').replace(/[-\s]/g, '').slice(0, 8) === ad) : null;
    if (!p && nev) { const n = nev.trim().toLowerCase(); p = this.partnerek.find(x => (x.nev || '').trim().toLowerCase() === n); }
    return p || null;
  }
  // Új partner létrehozása a tételhez. Ha van adószám, a NAV-tól lekérjük a teljes cégadatot
  // (név, teljes adószám, cím) és azzal töltjük ki a partnert – nem csak a nevet.
  async partnerLetrehoz(prefillNev?: string, prefillAdoszam?: string, cim?: any) {
    let nev = (prefillNev != null ? prefillNev : this.partnerKereso).trim();
    let adoszam = (prefillAdoszam || '').trim();
    // Ha a kereső mezőbe adószámot írtak, abból is dolgozhatunk.
    if (!adoszam && /\d{8}/.test(nev.replace(/\D/g, ''))) adoszam = nev;
    // Alap: név + adószám + (magánszemélynél) a számláról jövő cím-adatok.
    let adat: any = { nev, adoszam: adoszam || null, irsz: cim?.irsz || null, telepules: cim?.telepules || null, cim: cim?.cim || null, orszagkod: cim?.orszagkod || null };
    if (adoszam) {
      try {
        const t: any = await this.naplo.get('/osa/taxpayer/' + this.aktiv.ugyfelId + '?adoszam=' + encodeURIComponent(adoszam));
        if (t?.nev) {
          adat = { nev: t.nev, rovid_nev: t.rovid_nev || null, adoszam: t.adoszam || adoszam, irsz: t.irsz || adat.irsz, telepules: t.telepules || adat.telepules, cim: t.cim || adat.cim, orszagkod: t.orszagkod || adat.orszagkod };
          nev = t.nev;
        }
      } catch (e: any) { this.hiba('NAV cégadat-lekérés nem sikerült (' + (e?.error?.error || 'hiba') + '), a számla adataiból jön létre.'); }
    }
    if (!adat.nev) return this.hiba('Adj meg egy nevet vagy adószámot.');
    try {
      const r: any = await this.naplo.post('/partner', { ugyfel_id: this.aktiv.ugyfelId, ...adat });
      this.partnerek = await this.naplo.get('/partnerek/' + this.aktiv.ugyfelId);
      const uj = this.partnerek.find(x => x.id === r.id);
      if (uj) this.partnerValaszt(uj);
      this.ok('Partner létrehozva: ' + nev);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült létrehozni a partnert.'); }
  }

  sorBrutto(s: any) { return Number(s.brutto) || 0; }
  get tetelOsszeg() { return (this.szerk?.sorok || []).reduce((a: number, s: any) => a + this.sorBrutto(s), 0); }

  /* ── Bevallási sor kiválasztása a törzsből (bevsor-valaszto) ── */
  bevsorCel: { obj: any; mezo: string } | null = null;
  bevsorNevek = new Map<string, string>();
  bevsorNyit(obj: any, mezo: string) { this.bevsorCel = { obj, mezo }; }
  bevsorValaszt(s: { kod: string; nev: string }) {
    if (this.bevsorCel) this.bevsorCel.obj[this.bevsorCel.mezo] = s.kod;
    this.bevsorNevek.set(s.kod, s.nev);
    this.bevsorCel = null;
  }
  async bevsorNevekBetolt() {
    try {
      const l: any[] = await firstValueFrom(this.http.get<any[]>('/api/naplo-naplok/bevallas-sorok?mind=1'));
      this.bevsorNevek = new Map(l.map((x) => [x.kod, x.nev]));
    } catch { /* a kód is elég */ }
  }
  bevsorNev(kod: string | null | undefined): string { return kod ? this.bevsorNevek.get(kod) || '' : ''; }

  /*  A Naplókból nyitva: ide térünk vissza („Vissza a naplóhoz", és mentés után magától). */
  visszaUt: string | null = null;
  private parameterLevetel = false;
  visszaNaplo(kijelol?: string | null) {
    const ut = this.visszaUt;
    if (!ut) return;
    this.visszaUt = null;
    this.zarEngedd();
    // A kiinduló sor (ha volt) már benne van az útban; új tételnél a mentett bizonylat lesz kijelölve.
    this.router.navigateByUrl(ut + (kijelol && !/[?&]kijelol=/.test(ut) ? `&kijelol=${encodeURIComponent(kijelol)}` : ''));
  }

  async mentes(ujUtana = false) {
    if (this.zarTilt) return;
    if (!this.szerk?.datum) return this.hiba('A dátum kötelező.');
    const ervenyes = (this.szerk.sorok || []).filter((s: any) => s.rovat_id && (Number(s.brutto) || Number(s.netto)));
    if (!ervenyes.length) return this.hiba('Legalább egy rovatsort értékkel meg kell adni.');
    this.szerk.sorok = ervenyes;
    try {
      let id = this.szerk.id;
      if (this.szerk.id) await this.naplo.put('/tetel/' + this.szerk.id + this.naplo.evq(), this.szerk);
      else id = ((await this.naplo.post('/tetel' + this.naplo.evq(), this.szerk)) as any)?.id || null;
      this.ok('Tétel mentve.');
      const stornoUtana = this.stornoPar && this.stornoParJelol && this.szerk?.osa_szamlaszam === this.stornoPar.eredeti_szamlaszam ? this.stornoPar : null;
      this.stornoPar = null;
      if (stornoUtana) { try { await this.stornoKuld(stornoUtana); } catch (e: any) { this.hiba(e?.error?.error || 'A storno könyvelése nem sikerült.'); } }
      const modosito = this.modositoPar && this.szerk?.osa_szamlaszam === this.modositoPar.szamlaszam ? this.modositoPar : null;
      this.modositoPar = null;
      if (modosito && id) {
        try { const r: any = await this.naplo.post(`/osa/modosito/${this.aktiv.ugyfelId}`, { modosito, tetel_id: id }); this.ok(r?.fuggo ? `A módosító könyvelve. ${r.uzenet}` : `A módosító az eredetihez (${modosito.eredeti_szamlaszam}) kötve.`); }
        catch (e: any) { this.hiba(e?.error?.error || 'A módosítót nem sikerült az eredetihez kötni.'); }
      }
      if (this.visszaUt) { this.visszaNaplo(id); return; }   // a Naplókból nyitva: vissza oda
      await this.betoltTetelek();
      await this.betoltKeret();
      // „Mentés / Új tétel”: mentés után mindig üres űrlap jön, a következő tételhez.
      this.uj(); this.urlapFokusz();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }

  async torol(t: any) {
    if (t.id === this.szerk?.id && this.zarTilt) return;
    const a = await this.alert.create({
      header: 'Törlés', message: `Biztosan törli a ${t.sorszam}. tételt?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, {
        text: 'Törlés', role: 'destructive', handler: async () => {
          try { await this.naplo.del('/tetel/' + t.id); await this.betoltTetelek(); if (this.szerk?.id === t.id) this.uj(); this.ok('Törölve.'); }
          catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült törölni.'); }
        }
      }],
    });
    a.present();
  }

  // ---- OSA számlaválasztó ----
  /*  Számla behúzása: a közös választó (osa-valaszto) nyílik – a tárolt számlákkal, és a
   *  NAV-lekérés magától indul. A kiválasztott számla a könyvelőablakba kerül. */
  osaIndit() {
    this.osaNezet = null;
    this.osaModal.present();
  }
  /** A választóból: a számla teljes adata, majd kitöltött könyvelőablak (mint eddig a „Könyvelés ebből"). */
  async osaValasztKonyvel(sz: any) {
    this.stornoPar = null; this.modositoPar = null;
    if (stornoE(sz)) return this.stornoKonyvel(sz);
    if (String(sz?.muvelet || '').toUpperCase() === 'MODIFY' && sz?.eredeti_szamlaszam) {
      await this.osaMegnyit(sz);
      if (this.osaNezet) await this.osaKonyvel();
      if (this.szerk?.osa_szamlaszam === sz.szamlaszam) this.modositoPar = sz;
      return;
    }
    const par = await stornoParKeres(this.naplo, this.aktiv.ugyfelId as string, sz, (x) => !!x.konyvelt);
    await this.osaMegnyit(sz);
    if (this.osaNezet) await this.osaKonyvel();
    if (par && this.szerk?.osa_szamlaszam === sz.szamlaszam) { this.stornoPar = par; this.stornoParJelol = true; }
  }

  /*  STORNO SZÁMLA: ha az eredeti már könyvelt, a storno a tükre lesz (negatív összegek, 0 egyenleg);
   *  ha még nincs, az eredeti nyílik meg, és a mentésével együtt a storno is könyvelődik.
   *  (backend: naplo.js /osa/storno) */
  stornoPar: any = null;
  stornoParJelol = true;
  private async stornoKonyvel(st: any) {
    const eredeti = await eredetiKeres(this.naplo, this.aktiv.ugyfelId as string, st);
    if (eredeti && !eredeti.konyvelt) {
      this.ok(`Az eredeti számla (${eredeti.szamlaszam}) még nincs könyvelve – azt nyitom meg; a mentéskor a storno is vele együtt könyvelődik (0 egyenleg).`);
      await this.osaMegnyit(eredeti);
      if (this.osaNezet) await this.osaKonyvel();
      if (this.szerk?.osa_szamlaszam === eredeti.szamlaszam) { this.stornoPar = st; this.stornoParJelol = true; }
      return;
    }
    //  Az eredeti könyvelt (vagy a listában nincs, de kézzel, a számlaszámmal könyvelték): a tükör.
    try { await this.stornoKuld(st, true); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült lekönyvelni a storno számlát.'); }
  }
  private async stornoKuld(st: any, kerdez = false): Promise<void> {
    if (kerdez) {
      const a = await this.alert.create({ header: 'Storno számla',
        message: `A(z) ${st.szamlaszam} az eredeti ${st.eredeti_szamlaszam} számla sztornója. Lekönyveljem az eredeti tükreként (negatív összeggel, 0 egyenlegre)?`,
        buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Könyvelés', role: 'ok' }] });
      await a.present();
      if ((await a.onDidDismiss()).role !== 'ok') return;
    }
    await this.naplo.post(`/osa/storno/${this.aktiv.ugyfelId}`, { storno: st, eredeti_szamlaszam: st.eredeti_szamlaszam });
    await this.osaValaszto?.cacheBetolt();
    await this.betoltTetelek();
    this.ok(`Storno lekönyvelve (${st.szamlaszam}) – az eredeti tükreként.`);
  }
  /** A választóból: a kijelölt számlák csoportos könyvelése (egyszeres: rovatos tételek). */
  async osaTomeges(lista: any[]) {
    if (!lista?.length) return;
    const direction = (lista[0].irany === 'outbound' || lista[0].irany === 'bevetel') ? 'outbound' : 'inbound';
    try {
      const r: any = await this.naplo.post('/osa/konyvel-tomeges/' + this.aktiv.ugyfelId,
        { direction, szamlak: lista.map((s: any) => ({ szamlaszam: s.szamlaszam, batchIndex: s.batchIndex })) });
      await this.osaValaszto?.cacheBetolt();
      await this.betoltTetelek();
      const hibaSzov = r?.hibak?.length ? ' Hibák: ' + r.hibak.slice(0, 3).join('; ') : '';
      this.ok(`Csoportos könyvelés kész. Könyvelve: ${r?.konyvelt ?? 0}, kihagyva: ${r?.kihagyott ?? 0}.${hibaSzov}`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Csoportos könyvelés sikertelen.'); }
  }
  // Az ideiglenes tárból (NAV-hívás nélkül) – itt látszik a zöld "konyvelt" jelzés is.
  async osaCacheBetolt() {
    this.osaLoading = true; this.osaNezet = null;
    try {
      const r: any = await this.naplo.get('/osa/cache/' + this.aktiv.ugyfelId + '?direction=' + this.osaSzuro.direction);
      this.osaSzamlak = r.szamlak || []; this.osaKijelolt.clear();
    } catch { /* csendes – a NAV-frissítés úgyis elérhető */ }
    finally { this.osaLoading = false; }
  }
  // Frissítés a NAV-ból (digest), a cache-be is beíródik.
  // Előnézet-mód: a lekérdezés eredménye NEM íródik be automatikusan – a felhasználó
  // választja ki, melyik számlát emeli be. Így korábbi évek időszaka is lekérdezhető
  // anélkül, hogy az összes régi számla bekerülne az idei listába.
  osaElonezet = false;
  osaBeemelFut = false;

  async osaKeres() {
    this.osaLoading = true; this.osaNezet = null;
    try {
      const p = new URLSearchParams({ direction: this.osaSzuro.direction, dateFrom: this.osaSzuro.dateFrom, dateTo: this.osaSzuro.dateTo, reszletes: this.osaSzuro.reszletes ? '1' : '0' });
      if (this.osaElonezet) p.set('elonezet', '1');
      const r: any = await this.naplo.get('/osa/digest/' + this.aktiv.ugyfelId + '?' + p.toString());
      this.osaSzamlak = r.szamlak || []; this.osaKijelolt.clear();
      if (!this.osaSzamlak.length) this.ok('Nincs számla a megadott időszakban.');
      else if (this.osaElonezet) {
        const uj = this.osaSzamlak.filter((s: any) => !s.mar_beemelve).length;
        this.ok(`${this.osaSzamlak.length} számla az időszakban (${uj} még nincs beemelve). Jelöld ki, melyiket kéred.`);
      }
    } catch (e: any) { this.hiba(e?.error?.error || 'OSA lekérés sikertelen.'); }
    finally { this.osaLoading = false; }
  }

  // A kijelölt (előnézetben lévő) számlák beemelése – a NAV-tól újra lekérve, részletesen.
  async osaBeemel() {
    const szamlaszamok = Array.from(this.osaKijelolt);
    if (!szamlaszamok.length) { this.hiba('Jelöld ki, melyik számlákat emeljem be.'); return; }
    this.osaBeemelFut = true;
    try {
      const r: any = await this.naplo.post('/osa/beemel/' + this.aktiv.ugyfelId, {
        direction: this.osaSzuro.direction, szamlaszamok,
      });
      this.ok(`${r?.beemelve || 0} számla beemelve.` + (r?.hibak?.length ? ` (${r.hibak.length} sikertelen)` : ''));
      this.osaKijelolt.clear();
      this.osaElonezet = false;
      await this.osaCacheBetolt();          // a beemeltek már a rendes listában vannak
    } catch (e: any) { this.hiba(e?.error?.error || 'A beemelés nem sikerült.'); }
    finally { this.osaBeemelFut = false; }
  }

  // ---- Csoportos (tömeges) könyvelés ----
  get osaKijeloltDb() { return this.osaKijelolt.size; }
  get osaKonyveletlenek() { return (this.osaSzamlak || []).filter((s: any) => !s.konyvelt); }
  get osaMindKijelolve() { const k = this.osaKonyveletlenek; return k.length > 0 && k.every((s: any) => this.osaKijelolt.has(s.szamlaszam)); }
  osaKijelolValt(sz: any) {
    if (this.osaKijelolt.has(sz.szamlaszam)) this.osaKijelolt.delete(sz.szamlaszam);
    else this.osaKijelolt.add(sz.szamlaszam);
  }
  osaKijelolMind() {
    if (this.osaMindKijelolve) this.osaKijelolt.clear();
    else for (const s of this.osaKonyveletlenek) this.osaKijelolt.add(s.szamlaszam);
  }
  async osaCsoportKonyvel() {
    const valasztott = this.osaKonyveletlenek.filter((s: any) => this.osaKijelolt.has(s.szamlaszam));
    if (!valasztott.length) return this.hiba('Jelölj ki legalább egy (még nem könyvelt) számlát.');
    // Az irány a kiválasztott listából (a szűrő iránya); a digest sorai egységes irányúak.
    const direction = (valasztott[0].irany === 'outbound' || this.osaSzuro.direction === 'outbound') ? 'outbound' : 'inbound';
    this.osaLoading = true;
    try {
      const r: any = await this.naplo.post('/osa/konyvel-tomeges/' + this.aktiv.ugyfelId,
        { direction, szamlak: valasztott.map((s: any) => ({ szamlaszam: s.szamlaszam, batchIndex: s.batchIndex })) });
      this.osaKijelolt.clear();
      await this.osaCacheBetolt();
      await this.betoltTetelek();
      const hibaSzov = r?.hibak?.length ? ' Hibák: ' + r.hibak.slice(0, 3).join('; ') : '';
      this.ok(`Csoportos könyvelés kész. Könyvelve: ${r?.konyvelt ?? 0}, kihagyva: ${r?.kihagyott ?? 0}.${hibaSzov}`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Csoportos könyvelés sikertelen.'); }
    finally { this.osaLoading = false; }
  }
  // A listázott OSA-számlák partnereit tömegesen felveszi a partner-törzsbe (magánszemélyt is).
  async osaPartnerekKinyer() {
    const lista = (this.osaSzamlak || []).filter((s: any) => s.partner_nev).map((s: any) => ({ nev: s.partner_nev, adoszam: s.partner_adoszam }));
    if (!lista.length) return this.hiba('Nincs partner a listában (előbb frissíts a NAV-ból).');
    try {
      const r: any = await this.naplo.post('/osa/partnerek-kinyer/' + this.aktiv.ugyfelId, { partnerek: lista });
      this.partnerek = await this.naplo.get('/partnerek/' + this.aktiv.ugyfelId);
      this.ok(`Partnerek kinyerve: ${r?.letrehozott ?? 0} új.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült kinyerni a partnereket.'); }
  }

  // Számla kiválasztása: letölti a teljes adatot, megmutatja a könyvelési nézetet.
  async osaMegnyit(sz: any) {
    this.osaLoading = true;
    try {
      const p = new URLSearchParams({ invoiceNumber: sz.szamlaszam, direction: sz.irany === 'outbound' ? 'outbound' : 'inbound' });
      const r: any = await this.naplo.get('/osa/data/' + this.aktiv.ugyfelId + '?' + p.toString());
      this.osaNezet = { ...r.szamla, konyvelt: sz.konyvelt };
    } catch (e: any) { this.hiba(e?.error?.error || 'Számla letöltése sikertelen.'); }
    finally { this.osaLoading = false; }
  }
  //  Számlakép: ELŐBB a CSATOLT EREDETI kép (dokumentumtár / számlázóprogram / letöltött NAV Számlázó –
  //  backend szamlaKepBiztos); csak ha nincs ilyen, akkor a GENERÁLT (nyomtatható) nézet.
  async osaSzamlakep(sz: any) {
    // előbb nyitunk egy ablakot (popup-blokkolás elkerülése), majd betöltjük az adatot
    const w = window.open('', 'szamlakep', 'width=820,height=900,scrollbars=yes');
    if (w) w.document.write('<p style="font-family:sans-serif;padding:20px">Számlakép betöltése…</p>');
    const u = this.aktiv.ugyfelId;
    try {
      const ir = sz.irany === 'outbound' ? 'outbound' : 'inbound';
      const blob = await this.naplo.getBlob(`/nav/szamlazo/pdf-szamlaszam/${u}?szamlaszam=${encodeURIComponent(sz.szamlaszam)}&irany=${ir}`);
      if (blob && blob.size) { if (w) w.location.href = URL.createObjectURL(blob); return; }
    } catch { /* nincs csatolt eredeti → generált nézet */ }
    try {
      const p = new URLSearchParams({ szamlaszam: sz.szamlaszam, direction: sz.irany === 'outbound' ? 'outbound' : 'inbound' });
      const r: any = await this.naplo.get('/osa/szamlakep/' + u + '?' + p.toString());
      szamlakepAblakba(w, r.szamla);
    } catch (e: any) {
      if (w) w.close();
      this.hiba(e?.error?.error || 'Számlakép letöltése sikertelen.');
    }
  }

  // A tétel-modalból: a tételhez tartozó számla képe (feltöltött, ha van; különben generált OSA-kép).
  nyitSzamlaKep() {
    if (this.szerk?.kep_nev && this.szerk?.id) {
      this.data.megnyitFajl('/api/naplo/osa/kep/' + this.szerk.id, 'Számlakép');
      return;
    }
    if (this.szerk?.osa_teljes?.tetelsorok) {
      const w = window.open('', 'szamlakep', 'width=820,height=900,scrollbars=yes');
      szamlakepAblakba(w, this.szerk.osa_teljes);
      return;
    }
    if (this.szerk?.osa_szamlaszam) {
      this.osaSzamlakep({ szamlaszam: this.szerk.osa_szamlaszam, irany: this.szerk.osa_irany === 'outbound' ? 'outbound' : 'inbound' });
    }
  }

  private fmt(n: any) { const x = Number(n); return Number.isFinite(x) ? x.toLocaleString('hu-HU') : ''; }
  // Egy különálló HTML-számlaképet ír a megnyitott ablakba.
  // A számlanézetből a könyvelési tétel kitöltése.
  // Fizetési mód (OSA-kód vagy magyar szöveg) → a megfelelő pénztár/bank id-je.
  valasztPenztar(fizmod?: string): string | null {
    const s = String(fizmod || '').toLowerCase();
    let tipus: string | null = null;
    if (/cash|készpénz|keszpenz|utánvét|utanvet/.test(s)) tipus = 'penztar';
    else if (/transfer|átutal|atutal|card|kártya|kartya|voucher/.test(s)) tipus = 'bank';
    const valasztott = (tipus ? this.penztarak.find((p: any) => p.tipus === tipus) : null) || this.penztarak[0];
    return valasztott?.id || null;
  }

  /** A NAV-számla sorának összegei forintban EGÉSZ számra (bruttó és ÁFA kerekítve, a nettó a különbség);
   *  nem forintos számlánál centes marad. A számla behúzásánál ebből jött a fillér (user, 2026-10-07). */
  private egeszOsszegek(s: any, deviza?: string) {
    if (deviza && String(deviza).toUpperCase() !== 'HUF') return { netto: s.netto, afa: s.afa, brutto: s.brutto };
    const brutto = Math.round(Number(s.brutto) || (Number(s.netto) || 0) + (Number(s.afa) || 0));
    const afa = Math.round(Number(s.afa) || 0);
    return { netto: brutto - afa, afa, brutto };
  }

  async osaKonyvel() {
    const sz = this.osaNezet; if (!sz) return;
    const bevetel = sz.irany === 'bevetel';
    const alapRovat = this.rovatok.find(r => r.oszlop === (bevetel ? 1 : 3)) || this.rovatok.find(r => bevetel ? (r.oszlop === 1 || r.oszlop === 2) : (r.oszlop >= 3));
    const sorok = (sz.sorok || []).map((s: any) => ({
      rovat_id: alapRovat?.id || null, rovatszam: alapRovat?.rovatszam || null, oszlop: alapRovat?.oszlop || null,
      talalt: !!alapRovat, irany: sz.irany, afa_kulcs: s.afa_kulcs, ...this.egeszOsszegek(s, sz.deviza),
      _osa: true,   // a partnernél tanult bevallási sor (bevTanultBetolt) ide is töltődik
    }));
    const ma = (sz.kelt || '').slice(0, 10) || new Date().toISOString().slice(0, 10);
    // Partner felismerése: ELŐSZÖR a NAV Számlázós PDF-ből kinyert partner (magánszemélynél az OSA gyakran
    // nem adja a vevő nevét), különben az OSA-adat.
    const np = sz.nav_partner || null;
    let partnerNev = np?.nev || sz.partner_nev || '';
    let partnerAdo = np?.adoszam || sz.partner_adoszam || null;
    let pCim = { irsz: np?.irsz || sz.partner_irsz || null, telepules: np?.telepules || sz.partner_telepules || null, cim: np?.cim || sz.partner_cim || null, orszagkod: sz.partner_orszagkod || null };
    // Magánszemély: ha nincs partner, kiolvassuk a számla PDF-jéből (szöveg → OCR).
    if (!partnerNev && sz.szamlaszam) {
      try {
        const pe: any = await this.naplo.get(`/osa/partner-pdfbol/${this.aktiv.ugyfelId}?szamlaszam=${encodeURIComponent(sz.szamlaszam)}`);
        if (pe?.ok && pe.partner?.nev) {
          partnerNev = pe.partner.nev; partnerAdo = pe.partner.adoszam || partnerAdo;
          pCim = { irsz: pe.partner.irsz || pCim.irsz, telepules: pe.partner.telepules || pCim.telepules, cim: pe.partner.cim || pCim.cim, orszagkod: pe.partner.orszagkod || pCim.orszagkod };
          this.ok(`Vevő kiolvasva a számlából${pe.ocr ? ' (OCR)' : ''}: ${pe.partner.nev}`);
        }
      } catch { /* nincs letöltött PDF v. nem olvasható */ }
    }
    const partner = this.partnerAutoMatch(partnerNev, partnerAdo);
    this.zarEngedd();   // új (még mentetlen) tétel – nincs zár
    this.szerk = {
      ugyfel_id: this.aktiv.ugyfelId, datum: ma, afa_esedekesseg: ma, bizonylatszam: sz.szamlaszam || '',
      // Pénztár a fizetési mód szerint: készpénz→pénztár, átutalás/kártya→bank (OSA paymentMethod vagy NAV PDF fizmod).
      penztar_id: this.valasztPenztar(sz.paymentMethod || np?.fizmod),
      partner_id: partner?.id || null, partner_nev: partner?.nev || partnerNev,
      partnerHianyzik: !partner && !!partnerNev, partnerAdoszam: partnerAdo,
      // a partner címe a számláról (magánszemélynél a hiányzó adatok kitöltéséhez; OCR-rel is)
      partnerCim: pCim,
      gyujto_id: null, megjegyzes: '', osa_szamlaszam: sz.szamlaszam, osa_irany: sz.irany === 'bevetel' ? 'outbound' : 'inbound',
      nav_pdf_id: sz.nav_pdf_id || null, dok_pdf_id: sz.dok_pdf_id || null,
      // a generált számlakép gyors megnyitásához eltároljuk az OSA-adatokat
      osa_tetelsorok: sz.tetelsorok || [], osa_teljes: sz,
      sorok: sorok.length ? sorok : [this.ujSor()],
    };
    this.osaModal.dismiss();
    this.sorokIgazit();
    this.urlapFokusz();
    this.bevTanultBetolt();
    if (this.szerk.partnerHianyzik) this.ok('A partner („' + this.szerk.partner_nev + '") nincs a törzsben – a partner mezőnél létrehozhatod.');
  }

  // Az OSA-számlából felajánlott partner létrehozása a hiányjelzésnél (címmel együtt, magánszemélynél is).
  async osaPartnerLetrehoz() {
    if (!this.szerk?.partnerHianyzik) return;
    await this.partnerLetrehoz(this.szerk.partner_nev, this.szerk.partnerAdoszam, this.szerk.partnerCim);
  }
  // A számlaszámhoz tartozó NAV Számlázós PDF megnyitása (új ablak) az OSA-nézetből/tételből.
  navPdfMegnyit(navPdfId: string) { if (navPdfId) this.data.megnyitFajl('/api/naplo/nav/szamlazo/pdf/' + navPdfId, 'NAV számla PDF'); }
  // Módosító/storno számla → az eredeti számla képének megnyitása.
  osaEredetiNyit(sz: any) { if (sz?.eredeti_szamlaszam) this.osaSzamlakep({ szamlaszam: sz.eredeti_szamlaszam, irany: sz.irany }); }
  // A számlaszámhoz párosított dokumentumtári PDF (számlakép) megnyitása új ablakban.
  dokPdfMegnyit(dokPdfId: string) { if (dokPdfId) this.data.megnyitFajl('/api/naplo/dokumentum/pdf/' + dokPdfId, 'Számlakép'); }

  // ---- Számlakép feltöltés (mentett tételhez) ----
  async kepFeltolt(ev: any) {
    const file = ev?.target?.files?.[0];
    if (!file || !this.szerk?.id) return;
    const fd = new FormData(); fd.append('file', file);
    try { await firstValueFrom(this.http.post('/api/naplo/osa/kep/' + this.szerk.id, fd)); this.szerk.kep_nev = file.name; this.ok('Számlakép társítva.'); }
    catch { this.hiba('Nem sikerült feltölteni a számlaképet.'); }
  }
  kepMegnyit() { if (this.szerk?.id) this.data.megnyitFajl('/api/naplo/osa/kep/' + this.szerk.id, 'Számlakép'); }
  async kepTorol() {
    if (!this.szerk?.id) return;
    try { await this.naplo.del('/osa/kep/' + this.szerk.id); this.szerk.kep_nev = null; this.ok('Számlakép törölve.'); }
    catch { this.hiba('Nem sikerült törölni.'); }
  }

  async rendez() {
    try { await this.naplo.post('/rendezes/' + this.aktiv.ugyfelId + this.naplo.evq(), {}); await this.betoltTetelek(); this.ok('Sorszámok rendezve.'); }
    catch { this.hiba('Nem sikerült rendezni.'); }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1500, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'danger' })).present(); }
}


